import React, { useState } from "react";
import { toast } from "sonner";
import api, { apiError } from "@/lib/api";
import Icon from "@/components/Icon";

export const Field = ({ label, hint, children, testid }) => (
  <div className="space-y-1.5" data-testid={testid}>
    {label && <label className="text-xs font-semibold text-muted-foreground uppercase tracking-wide">{label}</label>}
    {children}
    {hint && <p className="text-xs text-muted-foreground">{hint}</p>}
  </div>
);

export const Input = (p) => <input {...p} className={`w-full rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40 ${p.className || ""}`} />;
export const TextArea = (p) => <textarea {...p} className={`w-full rounded-xl border border-input bg-background px-3.5 py-2.5 text-sm outline-none focus:ring-2 focus:ring-primary/40 ${p.className || ""}`} />;

export function useUpload() {
  const [uploading, setUploading] = useState(false);
  const upload = async (file) => {
    setUploading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await api.post("/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
      return data.url;
    } catch (e) {
      toast.error(apiError(e.response?.data?.detail));
      return null;
    } finally { setUploading(false); }
  };
  return { upload, uploading };
}

export function FileButton({ accept, onUrl, label = "Upload file", testid, multiple = false }) {
  const { upload, uploading } = useUpload();
  return (
    <label data-testid={testid} className="flex items-center justify-center gap-2 w-full rounded-xl border border-dashed border-border bg-card px-4 py-4 text-sm cursor-pointer hover:bg-accent transition-colors">
      <Icon name={uploading ? "Loader2" : "Upload"} className={`h-4 w-4 ${uploading ? "animate-spin" : ""}`} />
      {uploading ? "Uploading..." : label}
      <input type="file" accept={accept} multiple={multiple} className="hidden" onChange={async (e) => {
        const files = Array.from(e.target.files || []);
        for (const f of files) { const url = await upload(f); if (url) onUrl(url, f.name); }
        e.target.value = "";
      }} />
    </label>
  );
}
